<!-- ====== SUBSCRIPTION SECTION: CUSTOM PRICING PAGE ====== -->
<app-leftsidebar></app-leftsidebar>
<app-header></app-header>
<div class="right-sec common-right-sec mt-5">
  <div class="common-right-sec-bg" tabindex="0">
    <div class="subscription-container">
      <!-- Loading state while fetching plans -->
      @if (isLoadingPlans) {
        <div class="d-flex justify-content-center align-items-center w-100" style="min-height: 400px;">
          <div class="text-center">
            <span class="spinner-border text-light mb-3" role="status" aria-hidden="true"></span>
            <p class="text-light">Loading subscription plans...</p>
          </div>
        </div>
      }

      <!-- Custom Pricing Page Content -->
      @if (!isLoadingPlans) {
        <div class="custom-pricing-page">
          <!-- Header -->
          <div class="pricing-header mb-4">
            <h2 class="text-light mb-3">Choose Your Plan</h2>
            <p class="text-light-50 mb-4">Select the perfect plan for your needs</p>
          </div>
          <!-- Interval Tabs (Monthly/Yearly) -->
          <div class="interval-tabs mb-4">
            <div class="btn-group" role="group">
              <button
                type="button"
                class="btn"
                [class.btn-primary]="selectedInterval === 'month'"
                [class.btn-outline-primary]="selectedInterval !== 'month'"
                (click)="onIntervalChange('month')">
                Monthly
              </button>
              <button
                type="button"
                class="btn"
                [class.btn-primary]="selectedInterval === 'year'"
                [class.btn-outline-primary]="selectedInterval !== 'year'"
                (click)="onIntervalChange('year')">
                Yearly
              </button>
            </div>
          </div>
          <!-- Plans Grid -->
          <div class="plans-grid">
            @for (plan of plans[selectedInterval]; track plan) {
              <div
                class="plan-card"
                [class.current-plan]="isCurrentPlan(plan)"
                [class.featured-plan]="plan.stripe_index === 2">
                <!-- Current Plan Badge -->
                @if (isCurrentPlan(plan)) {
                  <div class="current-plan-badge">
                    <span class="badge bg-success">Current Plan</span>
                  </div>
                }
                <!-- Product Image -->
                @if (plan.image) {
                  <div class="plan-image-container">
                    <img [src]="plan.image" [alt]="plan.name" class="plan-image" />
                  </div>
                }
                @if (!plan.image) {
                  <div class="plan-image-container">
                    <div class="plan-image-placeholder">
                      <i class="fas fa-cube"></i>
                    </div>
                  </div>
                }
                <!-- Plan Header -->
                <div class="plan-header">
                  <h3 class="plan-name">{{ plan.name }}</h3>
                  <div class="plan-price">
                    <span class="price-amount">${{ plan.price }}</span>
                    <span class="price-interval">/{{ plan.interval }}</span>
                  </div>
                </div>
                <!-- Plan Description -->
                @if (plan.description) {
                  <div class="plan-description">
                    <p>{{ plan.description }}</p>
                  </div>
                }
                <!-- Plan Features -->
                <div class="plan-features">
                  <ul class="feature-list">
                    @for (feature of plan.features; track feature) {
                      <li>
                        <i class="fas fa-check text-success me-2"></i>
                        {{ feature }}
                      </li>
                    }
                  </ul>
                </div>
                <!-- Plan Actions -->
                <div class="plan-actions">
                  @if (shouldShowSubscribe(plan)) {
                    <button
                      class="btn btn-primary w-100"
                      (click)="onSubscribeClick(plan)">
                      Subscribe
                    </button>
                  }
                  @if (shouldShowUpgrade(plan)) {
                    <button
                      class="btn btn-success w-100"
                      (click)="onUpgradeClick(plan)">
                      Upgrade
                    </button>
                  }
                  @if (shouldShowDowngrade(plan)) {
                    <button
                      class="btn btn-warning w-100"
                      (click)="onDowngradeClick(plan)">
                      Downgrade
                    </button>
                  }
                  @if (isCurrentPlan(plan)) {
                    <button
                      class="btn btn-outline-secondary w-100"
                      disabled>
                      Current plan
                    </button>
                  }
                </div>
              </div>
            }
          </div>
          <!-- Manage Billing Button removed - users can use Upgrade/Subscribe buttons on plan cards -->
          <!-- Empty State -->
          @if (plans[selectedInterval].length === 0) {
            <div class="text-center py-5">
              <p class="text-light">No plans available for {{ selectedInterval }}ly billing.</p>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
<app-footer></app-footer>
